import React from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { useMessage } from '../../hooks/message'
import { usePutRequest } from '../../hooks/request'
import { UTILITY_BILLS_DETAIL } from '../../urls'
import UtilityBillsForm from './UtilityBillsForm'
import Layout from '../../components/Layout'

export default function UtilityBillsUpdate({ onCancel }) {
    const [showMessage] = useMessage()
    const location = useLocation()
    const { marketId } = useParams()
    const item = location.state?.item || {} // Берем из state, если нет – пустой объект
    const history = useHistory()
    const client = usePutRequest({ url: UTILITY_BILLS_DETAIL.replace('{id}', item?.id) })

    async function onSubmit(data, action) {
        const { success, error } = await client.request({ data })

        if (success) {
            history.replace(`/rent/${marketId}/utility-bills/`)
            action.resetForm()
        }
        if (error) showMessage(error?.data?.detail || 'Ошибка', 'is-danger')
    }

    return (
        <Layout>
            <UtilityBillsForm marketId={marketId} loading={client.loading} initialValues={item} onCancel={onCancel} onSubmit={onSubmit} />
        </Layout>
    )
}
